import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import ExemptSubMenu from '@/components/nav/ExemptSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Popup990 from '@/components/ui/Form990Popup';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form990SCH = () => {
  // Define an array of imported images

  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Simplify your nonprofit's tax return with Form 990-EZ.`,
  //   SubHeading:
  //     'E-file now for a seamless experience. Stay tax-exempt and file confidently.',
  //   CtaText: 'E-file Form 990-EZ Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form990schedulessticky`,
  //   isActive: true,
  // };
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 5, 15));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 5, 15)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },

            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
            color: '#d7d7d7',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      //  LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="Effortless Form 990 & 990-EZ E-filing with ALL Schedules"
          description="Don't stress about Form 990 schedules! TaxZerone guides you & e-files your Form 990 & ALL required schedules for FREE. Get Started Today!"
          keywords="Form 990-EZ, Nonprofit Taxes, Exempt Org. Taxes"
          canonical="tax-exempt/e-file-irs-form-990-schedules/"
          jsonLdPricing="89.99"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="2063"
          ogShareImg="assets/images/exempt-share-img.png"
        />
      }
    >
      <ExemptSubMenu />
      <Popup990 />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Container
        component="section"
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: '#ffe400',
            p: 1.5,
            px: 2.5,
            color: '#444',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 16, sm: 17, md: 18, lg: '1.25rem' },
                lineHeight: 1.3,
              }}
            >
              <b style={{ color: '#c71f1f' }}> Attention Nonprofits!</b> E-file
              your
              <b> 2025 Form 990 Series</b> returns today and stay compliant with
              IRS requirements.
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time Left Until the Deadline
                <span style={{ fontWeight: 600, color: '#1c1c1c' }}>
                  ( May 15, 2026)
                </span>
                :
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                size="large"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=990sch`}
                sx={{
                  backgroundColor: '#c02652',
                  '&:hover, &:focus': {
                    backgroundColor: '#3e663b',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#fff',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-file Now!
              </Button>
              {/* <Typography variant="body2" sx={{ textAlign: 'center', mt: 1 }}>
                {' '}
                <b> Save 10%</b> with code{' '}
                <b style={{ color: '#c02652' }}> TZOTE10</b>
              </Typography> */}
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl" component="section">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File IRS{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 990-Schedules</span>
                </span>{' '}
                Easily for the 2025 Tax Year with TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                TaxZerone handles all{' '}
                <span style={{ fontWeight: 600 }}>
                  Form 990 and 990-EZ schedules
                </span>{' '}
                for the 2025 tax year. Complete your form and all required
                schedules electronically.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form990schedules`}
                  >
                    Get Started Now
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/schedules-landing-img.webp" />
                <source srcSet="/assets/images/schedules-landing-img.png" />
                <img
                  src="/assets/images/schedules-landing-img.png"
                  alt="E-File IRS Form 990-Schedules Easily with TaxZerone"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/schedules-landing-img-sm.webp" />
                <source srcSet="/assets/images/schedules-landing-img-sm.png" />
                <img
                  src="/assets/images/ez-landing-img-sm.png"
                  alt="E-File IRS Form 990-Schedules Easily with TaxZerone"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          overflow: 'hidden',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="stretch"
            spacing={2}
            m={2}
            mt={5}
            pb={5}
            mb={{ xs: 5, sm: 5 }}
            className="MuiGrid-root-width"
            sx={{ '& i': { fontSize: 13, fontWeight: 500 } }}
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Form 990 & 990-EZ Schedules: A Complete List
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Find the specific schedule(s) you need to file your tax return.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-a/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule A
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Public Charity Status and Public Support.
                  <br />
                  <i>(Applicable to Forms 990 and 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-a-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-a-img.png" />
                    <img
                      src="/assets/images/schedules/sch-a-img.png"
                      alt="Schedule A"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-b/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule B
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule of Contributors.
                  <br />
                  <i>(Applicable to Forms 990, 990-EZ, and 990-PF)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-b-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-b-img.png" />
                    <img
                      src="/assets/images/schedules/sch-b-img.png"
                      alt="Schedule B"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-c/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule C
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Political Campaign and Lobbying Activities.
                  <br />
                  <i>(Applicable to Forms 990 and 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-c-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-c-img.png" />
                    <img
                      src="/assets/images/schedules/sch-c-img.png"
                      alt="Schedule C"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-d/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule D
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Supplemental Financial Statements. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-d-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-d-img.png" />
                    <img
                      src="/assets/images/schedules/sch-d-img.png"
                      alt="Schedule D"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-e/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule E
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schools. <br />
                  <i>(Applicable to Forms 990 and 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-e-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-e-img.png" />
                    <img
                      src="/assets/images/schedules/sch-e-img.png"
                      alt="Schedule E"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-f/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule F
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Statement of Activities Outside the United States. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-f-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-f-img.png" />
                    <img
                      src="/assets/images/schedules/sch-f-img.png"
                      alt="Schedule F"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-g/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule G
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Supplemental Information Regarding Fundraising or Gaming
                  Activities. <br />
                  <i>(Applicable to Forms 990 or 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-g-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-g-img.png" />
                    <img
                      src="/assets/images/schedules/sch-g-img.png"
                      alt="Schedule G"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-i/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule I
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Grants and Other Assistance to Organizations, Governments, and
                  Individuals in the United States. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-i-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-i-img.png" />
                    <img
                      src="/assets/images/schedules/sch-i-img.png"
                      alt="Schedule I"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-j/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule J
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Compensation Information. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-j-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-j-img.png" />
                    <img
                      src="/assets/images/schedules/sch-j-img.png"
                      alt="Schedule J"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-k/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule K
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Supplemental Information on Tax-Exempt Bonds. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-k-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-k-img.png" />
                    <img
                      src="/assets/images/schedules/sch-k-img.png"
                      alt="Schedule K"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-l/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule L
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Transactions With Interested Persons. <br />
                  <i>(Applicable to Forms 990 and 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-l-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-l-img.png" />
                    <img
                      src="/assets/images/schedules/sch-l-img.png"
                      alt="Schedule L"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-m/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule M
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Noncash Contributions. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-m-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-m-img.png" />
                    <img
                      src="/assets/images/schedules/sch-m-img.png"
                      alt="Schedule M"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-n/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule N
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Liquidation, Termination, Dissolution, or Significant
                  Disposition of Assets. <br />
                  <i>(Applicable to Forms 990 and 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-n-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-n-img.png" />
                    <img
                      src="/assets/images/schedules/sch-n-img.png"
                      alt="Schedule N"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-o/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule O
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Supplemental Information to Form 990 or 990-EZ. <br />
                  <i>(Applicable to Forms 990 and 990-EZ)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-o-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-o-img.png" />
                    <img
                      src="/assets/images/schedules/sch-o-img.png"
                      alt="Schedule O"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderRadius: 3,
                  py: 2,
                  px: 0.75,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  borderWidth: 2,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{ fontSize: '24px !important', fontWeight: 600 }}
                >
                  <Link
                    href="/resources/tax-exempt/form-990-schedule-r/"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule R
                  </Link>
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Related Organizations and Unrelated Partnerships. <br />
                  <i>(Applicable to Forms 990)</i>
                </Typography>

                <Box
                  component="div"
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    '& img': {
                      border: '1px solid #ccc',
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      maxWidth: 320,
                      maxHeight: 293,
                    },
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/schedules/sch-r-img.webp" />
                    <source srcSet="/assets/images/schedules/sch-r-img.png" />
                    <img
                      src="/assets/images/schedules/sch-r-img.png"
                      alt="Schedule R"
                      loading="lazy"
                      width={320}
                      height={293}
                    />
                  </picture>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Simplify Your Nonprofit Tax Filing with TaxZerone
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Don&apos;t let complex schedules slow you down. Streamline your Form
          990 or 990-EZ
          <br />
          filing with TaxZerone&apos;s comprehensive schedule support.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form990schedules`}
          >
            Get Started with TaxZerone!
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg" component="section">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Which Form 990/990-EZ Schedules Do I Need?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    The specific schedules you need depend on your
                    organization&apos;s activities and financial situation.
                    However, some common schedules include:
                    <ul>
                      <li>
                        <b>Schedule A</b> (Forms 990 and 990EZ): Public Charity
                        Status and Public Support.
                      </li>
                      <li>
                        <b>Schedule B</b> (Forms 990, 990 EZ, and 990PF):
                        Schedule of Contributors
                      </li>
                      <li>
                        <b>Schedule G</b> (Forms 990 or 990EZ): Supplemental
                        Information Regarding Fundraising or Gaming Activities
                      </li>
                      <li>
                        <b>Schedule O</b> (Forms 990 and 990EZ): Supplemental
                        Information to Form 990 or 990EZ
                      </li>
                    </ul>
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Is There a Deadline for Filing Schedules with My Form
                  990/990-EZ?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    Yes, the deadline for filing your Form 990/990-EZ, including
                    all applicable schedules, is the same as the deadline for
                    your tax return. This is typically the 15th day of the fifth
                    month (May 15th) following your organization&apos;s fiscal
                    year-end. However, extensions can be obtained by filing Form
                    8868.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What Happens if I Miss a Schedule or Make a Mistake?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    If you accidentally omit a required schedule or make an
                    error, it&apos;s important to file an amended return as soon
                    as possible. TaxZerone can guide you through the amendment
                    process.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can I file electronically with all the schedules attached?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text" sx={{ mt: 1 }}>
                    Yes! TaxZerone allows you to e-file your Form 990 or 990-EZ
                    with all the completed schedules electronically.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Can TaxZerone help me e-file my Form 990/990-EZ with
                  schedules?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" sx={{ mt: 1 }} itemProp="text">
                    Absolutely! TaxZerone offers secure and convenient e-filing
                    for your Form 990/990-EZ, including all associated
                    schedules. This eliminates the need for paper filing and
                    ensures faster processing by the IRS.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form990SCH;
